import React, { useEffect, useState } from "react"
import { Platform } from "react-native";
import * as Notifications from "expo-notifications";
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import BottomTabBarStack from "./BottomTabBarStack/BottomTabBarStack"
import RegisterLoginStack from "@Navigation/RegisterLoginStack/RegisterLoginStack"
import { SurveyFinished } from "@Screens/Diagnostic/SurveyFinished"
import { GoalFinished } from "@Screens/FollowUp/Goals/GoalFinished"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { useRecoilState } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { LoadingPage } from "@Screens/Loading/Loading"
import { StatusBar } from "expo-status-bar"
import { UserService } from "@Services/User.service"
import { DiagnosticFinished } from "@Screens/Diagnostic/DiagnosticFinished"
import FirstConsent from "@Screens/FirstConsent/FirstConsent"
import CheckingLastState from "./CheckingLastState"
import { useConsentHooks } from "../Hooks/useConsentHooks"
import MainLoading from "@Screens/MainLoading/MainLoading"

import { messaging, getToken, onMessage } from "../Services/FirebaseConfig";

export async function registerForPushNotificationsAsync() {
  if (Platform.OS === "web") {
    const permission = await Notification.requestPermission();
    console.log('=============== permission =====================');
    console.log(permission);
    console.log('====================================');
    if (permission === "granted") {
      const token = await getToken(messaging);
      
      console.log('=============== Web Token =====================');
      console.log(token);
      console.log('====================================');
      return token;
    }
  } else {
    const { status } = await Notifications.requestPermissionsAsync();
    if (status === "granted") {
      const token = (await Notifications.getExpoPushTokenAsync()).data;
      console.log("Mobile Token:", token);
      return token;
    }
  }
}

const MainStackNavigator = createNativeStackNavigator()


const RootNavigation = ({ navigation }) => {
    const [userData, setUserData] = useRecoilState(userAtom)
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(false)
    const { handleFetchConsent } = useConsentHooks()

    const [expoPushToken, setExpoPushToken] = useState("");

  useEffect(() => {
    registerForPushNotificationsAsync().then((token) => {
        console.log("token token token token:", token);
      setExpoPushToken(token);
    });

    // Gestion des notifications en premier plan (web et mobile)
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Notification en premier plan:", payload);
    });

    return unsubscribe;
  }, []);
    
//       useEffect(() => {
//         async function registerForPushNotifications() {
//           try {
//             const token = await getToken(messaging, {
//               vapidKey: "1:246497724750:web:9937bdf7c51d53580a761f",
//             });
//             setExpoPushToken(token);
//             console.log("Push Token:", token);
//           } catch (error) {
//             console.error("Erreur lors de l'enregistrement des notifications", error);
//           }
//         }

//         // Obtenir le token pour les notifications
//         async function requestPermission() {
//             const permission = await Notification.requestPermission();
//             if (permission === 'granted') {

//                 registerForPushNotifications();
        
//             // Gérer les notifications en premier plan
//             onMessage(messaging, (payload) => {
//                 console.log("Notification reçue :", payload);
//             });
//             } else {
//             console.log('⛔ Permission refusée');
//             }
//         }
        
//   requestPermission();
    

          
//       }, []);

    useEffect(() => {
        setLoading(true)
        UserService.getUserData()
            .then((response) => {
                const user = response?.data?.data
                setUserData(user)
                if (user) {
                    setUserData(user)
                    setUser(user)
                    LocalStorage.saveUser(user)
                    handleFetchConsent()
                    // navigation.navigate("Root", { screen: "Main" })
                }
                setLoading(false)
            })
            .catch((e) => {
                if (e?.response?.data?.status === 401 || e.response?.status === 401) {
                    LocalStorage.clearAll();
                    setUserData(null);
                    navigation.navigate("Root", { screen: "RegisterLoginStack" })
                }
                setLoading(false)
            })
    }, [])

    const loadingPage = loading

    if (loadingPage) {
        return <MainLoading />
    }

    return (
        <MainStackNavigator.Navigator
            screenOptions={{
                headerShown: false
            }}
            // initialRouteName={"Main"}
            initialRouteName={"CheckingLastState"}
        >
            {loadingPage ? (
                <MainStackNavigator.Screen name="Loading" component={LoadingPage} />
            ) : userData ? (
                <>
                    <MainStackNavigator.Screen name="CheckingLastState" component={CheckingLastState} />
                    <MainStackNavigator.Screen name="FirstConsent" component={FirstConsent} />
                    <MainStackNavigator.Screen name="Main" component={BottomTabBarStack} />
                    <MainStackNavigator.Screen name="SurveyFinished" component={SurveyFinished} />
                    <MainStackNavigator.Screen name="DiagnosticFinished" component={DiagnosticFinished} />
                    <MainStackNavigator.Screen name="GoalFinished" component={GoalFinished} />
                </>
            ) : (
                <MainStackNavigator.Screen name="RegisterLoginStack" component={RegisterLoginStack} />
            )}
        </MainStackNavigator.Navigator>
    )
}
const AppNavigation = () => {
    return (
        <MainStackNavigator.Navigator
            screenOptions={{
                headerShown: true,
                header: () => <StatusBar translucent />
            }}
        >
            <MainStackNavigator.Screen name="Root" component={RootNavigation}></MainStackNavigator.Screen>
        </MainStackNavigator.Navigator>
    )
}

export default AppNavigation
